import React from 'react';

import {
  Container,
  ImageShadowContainer,
  LabelShadowContainer,
  Label,
  Image,
} from './photoWithLabel.styled';
import { PhotoWithLabelComponentData } from './photoWithLabel.types';

export const PhotoWithLabel: React.FC<PhotoWithLabelComponentData> = (data: PhotoWithLabelComponentData) => {
  const { photo, label, externalPage } = data.data;

  return (
    <Container target='_blank' href={externalPage}>
      <Image src={photo?.localFile?.url} alt='background' />
      <ImageShadowContainer>
        <LabelShadowContainer>
          <Label>{label}</Label>
        </LabelShadowContainer>
      </ImageShadowContainer>
    </Container>
  );
};
